import {toast} from 'react-toastify';


global.baseUrl = "https://api.geoticket.it";


global.getFormData = function (object) {
    const formData = new FormData();
    Object.keys(object).forEach((key) => {
        // if (object[key] !== null)
        formData.append(key, object[key])
    });
    // console.log("formData")
    // console.log(formData)
    return formData;
};

global.catchError = function (response) {
    if (response.status !== 200)
        response.json().then(response => {
            if (typeof response.error !== "undefined")
                toast.error("Errore! " + response.error);
            else
                toast.error("Errore generico, riprova più tardi");
        });
}

let route = {
    permission: "/app/permission",
    recoverPassword: "/app/user/password/recovery",
    login: "/app/user/login",
    register: "/app/user/register",
    editUser: "/app/user/edit",
    userDelete: "/app/user/delete",
    updatePassword: "/app/user/password/update",
    logout: "/app/user/logout",
    setNewsLetter: "/app/user/newsletter",

    areaListLevel: "/app/area/list/level",
    blogList: "/app/blog/list",
    blogInfo: "/app/blog/info",

    userListTicket: "/app/ticket/list",
    userTicketDownload: '/app/ticket/download',


    ticketListRecommended: "/app/v3/ticket/list/recommended",
    ticketAreaInfo: "/app/ticket/area/info",
    searchFilters: "/app/search/filters/v2",

    contactUs: "app/contact/us",


};

for (let i in route) {
    route[i] = global.baseUrl + route[i];
}

route.ai_map = "https://ai-api.geoticket.it/map";
route.ai_srv = "https://ai-api.geoticket.it";

global.route = route;
module.export = route;

global.permission = async () => {
    return new Promise((resolve, reject) => {

        fetch(global.route.permission, {
            method: "post", credentials: 'include'
        }).then(response => {
            if (response.status === 200) {
                response.json().then(response => {
                    resolve(response.user);
                });
            } else {
                response.json().then(response => {
                    if (typeof response.error !== "undefined")
                        reject({error: response.error});
                    reject({error: ""});

                });
            }
        }).catch(error => {
            reject({error: error});
        });
    });
}
